<template>
    <div>
        <div v-if="draw_categories && chartData">
            Colored by {{chartData.meta.color_by_field}}:
            <span v-for="category in categories_for_display" style="margin-right:4px;">
                <span
                        v-bind:style="{ borderBottom: category.color,padding:'3px', fontSize:'11px'}"
                        @mouseover="hover_category=category.category"
                        @mouseleave="hover_category=null">
                    {{category.category}}
                </span>
            </span>
        </div>
        <div ref="d3_root"></div>
        <div v-if="chartData && (!render_info || render_info.display_extra)">
            <span style="color:lightgray"><span style="color:#a1a1a1">Scatter</span>:
                <span  style="color:#a1a1a1">{{chartData.meta.x}}</span> ×
                <span  style="color:#a1a1a1">{{chartData.meta.y}}</span>
                labeled by <span  style="color:#a1a1a1">{{chartData.meta.label}}</span>
                <span v-if="chartData.meta.color_by_field">and colored by
                    <span  style="color:#a1a1a1">{{chartData.meta.color_by_field}}</span></span></span>
        </div>
    </div>
</template>

<script>
    import * as d3 from "d3";
    export default {
        data() {
            return {
                categories: {},
                categories_for_display: [],
                draw_categories: false,
                hover_category: null
            }
        },
        mounted() {
            if (this.chartData) {
                this.draw()
            }
        },
        watch: {
            chartData: function (newValue) {
                if (newValue) this.draw()
            },
            height: function(newValue) {
                if (newValue) this.draw()
            },
            text_size: function(newValue) {
                if (newValue) this.draw()
            },
            hover_category: function(newValue) {
                this.draw()
            }
        },
        props: ['height','width', 'text_size', 'chartData','render_info'],
        methods: {
            // https://stackoverflow.com/questions/51108964/shorten-number-labels-in-charts-js
            commarize(number) {
                let min = 1e3;
                // Alter numbers larger than 1k
                if (number >= min) {
                    var units = ["k", "M", "B", "T", "Q"];

                    var order = Math.floor(Math.log(number) / Math.log(1000));

                    var unitname = units[(order - 1)];
                    var num = Math.floor(number / 1000 ** order);

                    // output number remainder + unitname
                    return num + unitname
                }

                // return formatted original number
                return number.toLocaleString()
            },
            draw() {
                this.categories_for_display = []
                this.categories = []
                let count = 0;
                this.chartData.data.forEach(dataPoint => {
                    if (!this.categories[dataPoint.category]) {
                        console.log(dataPoint.category)
                        count++
                        this.categories[dataPoint.category] = dataPoint.color
                        let category_category = dataPoint.category
                        if (dataPoint.category===null) {
                            category_category = 'NO VALUE'
                        }
                        let category = {
                            category: category_category,
                            color: '3px solid ' + dataPoint.color
                        }
                        this.categories_for_display.push(category)
                    }
                })
                if (count>=2) {
                    this.draw_categories = true
                }

                // Modified from http://bl.ocks.org/weiglemc/6185069

                let data = this.chartData.data
                let meta = this.chartData.meta

                // note the right margin is 40, but when we set the width of the svg we actually add 20
                // this is for some buffer to the right for labels flowing over
                var margin = {top: 20, right: 40, bottom: 30, left: 40},
                    width = this.width - margin.left - margin.right,
                    height = this.height - margin.top - margin.bottom;
                /*
                 * value accessor - returns the value to encode for a given data object.
                 * scale - maps value to a visual display encoding, such as a pixel position.
                 * map function - maps from data value to display value
                 * axis - sets up axis
                 */

                let min_x = meta.min_x
                let min_y = meta.min_y
                let max_x = meta.max_x
                let max_y = meta.max_y
                let x_buffer = (max_x - min_x) * 0.01
                let y_buffer = (max_y - min_y) * 0.01

                console.log('(' + min_x + ',' + min_y + ') to (' + max_x + ',' + max_y + ')');

// setup x
                var xValue = function(d) { return d.x;}, // data -> value  David X
                    xScale = d3.scaleLinear().domain([min_x-x_buffer,max_x+x_buffer]).range([0, width]),
                    xMap = function(d) { return xScale(xValue(d));}, // data -> display
                    xAxis = d3.axisBottom(xScale).tickFormat((d) => {return this.commarize(d)});

// setup y
                var yValue = function(d) { return d.y;}, // data -> value  David Y
                    yScale = d3.scaleLinear().domain([min_y-y_buffer,max_y+y_buffer]).range([height, 0]), // value -> display
                    yMap = function(d) { return yScale(yValue(d));}, // data -> display
                    yAxis = d3.axisLeft(yScale).tickFormat((d) => {return this.commarize(d)});

                const svg_element = document.createElementNS("http://www.w3.org/2000/svg",'svg');

                let width_svg = width + margin.left + margin.right + 20
                let height_svg = height + margin.top + margin.bottom

// add the graph canvas to the body of the webpage
                var svg = d3.select(svg_element)
                    .attr("viewBox", `0 0 ${width_svg} ${height_svg}`)  // see note on setting margins above
                    .attr("height", height + margin.top + margin.bottom);

                let g = svg.append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

// add the tooltip area to the webpage
                var tooltip = d3.select("body").append("div")
                    .attr("class", "tooltip")
                    .style("opacity", 0);

                if (this.render_info && this.render_info.background_color_scale) {
                  var backgroundColors = ["#5E4FA2", "#3288BD", "#66C2A5", "#ABDDA4", "#E6F598",
                    "#FFFFBF", "#FEE08B", "#FDAE61", "#F46D43", "#D53E4F", "#9E0142"]
                  console.log(backgroundColors.length)
                  var backgroundScale =
                      d3.scaleLinear().
                      domain(d3.ticks(1, 10, 11)).
                      // domain(d3.ticks(1, 10, backgroundColors.length)).
                      range(backgroundColors)
                  console.log(backgroundScale(3))
                  g.append("rect")
                      .attr('x',0)
                      .attr('y',0)
                      .attr('width',width)
                      .attr('height',height)
                      .attr('fill-opacity',0.3)
                      .style('fill',backgroundScale(this.render_info.background_color_scale))
                }

// load data

                // x-axis
                g.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + height + ")")
                    .call(xAxis)
                    .append("text")
                    .attr("x", width)
                    .attr("y", -6)
                    .style("text-anchor", "end")
                    .style("fill","black")
                    .text(meta.x);

                // y-axis
                g.append("g")
                    .attr("class", "y axis")
                    .call(yAxis)
                    .append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("y", 6)
                    .attr("dy", ".71em")
                    .style("text-anchor", "end")
                    .style("fill","black")
                    .text(meta.y);

                // draw markers
                let enterSelection = g.selectAll(".marker")
                    .data(data)
                    .enter().append("circle")
                    .attr("class", "marker")
                    .attr("r", (d) => {return d.hasOwnProperty('size') ? d.size : 5})
                    .attr("cx", xMap)
                    .attr("cy", yMap)
                    .style("stroke", function(d) { return d.style==='hollow' ? d.color: null})
                    .style("stroke-width", function(d) { return d.style==='hollow' ? 1: 0})
                    .style("fill", function(d) { return d.color;})
                    .attr("fill-opacity", d => {
                        while (d.depth > 1) d = d.parent;
                        if (d.hasOwnProperty('opacity')) return d.opacity;
                        if (!this.hover_category) {
                            if (d.style==='hollow') return 0;
                            else return 0.6;
                        } else if (d.category==this.hover_category) {
                            return 0.95;
                        } else {
                            return 0.1;
                        }
                    })
                    .on("mouseover", function(d) {
                            tooltip.transition()
                                .duration(200)
                                .style("opacity", .9);
                            tooltip.html(d.category_actual
                                + "<br /><strong>"
                                +    d.label
                                + "</strong><br/> ("
                                +  (d.x_actual ? d.x_actual : xValue(d))
                                + ", "
                                + (d.y_actual ? d.y_actual : yValue(d))
                                + ")"
                                )
                                .style("left", (d3.event.pageX + 10) + "px")
                                .style("top", (d3.event.pageY - 60) + "px")
                                .style("background", d.color ? d.color : 'white')
                                .style("color",d.text_color ? d.text_color: 'black')
                                .style("opacity",0.7)
                                .style("padding","10px")
                            ;
                    })
                    .on("mouseout", function(d) {
                            tooltip.transition()
                                .duration(500)
                                .style("opacity", 0);
                    })
                    .on("click", (d) => {
                        this.$emit('dotClicked', d);
                    });

                g.selectAll(".marker_text")
                    .data(data)
                    .enter()
                    .append("text")
                    .attr("class", "marker_text")
                    .text((d)=>{if(!d.overlaps) {return d.label} else {return ''}})
                    .attr("x", (d) => xMap(d) + (d.hasOwnProperty('size') ? d.size : 5))
                    .attr("y", (d) => yMap(d) - (d.hasOwnProperty('size') ? d.size : 5))
                    .attr("font_family", "sans-serif")  // Font type
                    .attr("font-size", "11px")  // Font size
                    .attr("fill", "darkgray")   // Font color
                    .on("click", (d) => {
                        this.$emit('dotClicked', d);
                    })

                while (this.$refs.d3_root.firstChild) {
                    this.$refs.d3_root.removeChild(this.$refs.d3_root.firstChild);
                }

                this.$refs.d3_root.append(svg.node())

            },
        }
    }
</script>